<script setup lang="ts">
import TermsAndConditionsContent from '@components/ui/prepay&terms-and-conditions/TermsAndConditionsContent.vue';

defineProps<{
    mobilePage?: boolean;
}>();

const contentStore = useContentStore();
onBeforeMount(async () => await contentStore.getTermsAndCondition());
</script>
<template>
    <mr-modal title="شرایط و مقررات" class="modal" :mobile-page>
        <TermsAndConditionsContent class="terms-modal-content" />
    </mr-modal>
</template>

<style lang="scss" scoped>
.modal {
    @include mobile-only {
        overflow-y: scroll;
    }
}
.terms-modal-content {
    max-width: 1000px;
}
</style>
